import React, { useEffect } from "react";
import "./FlipCard.css";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Pillars() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div style={{ paddingBottom: "50px" }}>
      <center>
        <div className="ban-gap">
          <div className="icon-container">

            {/* Energy */}
            <a href="/conserve/energy/" className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <div aria-label="button">
                <div className="flip-button-image-1" />
              </div>
              <p className="topic-under-box">Energy</p>
            </a>

            {/* Water */}
            <a href="/conserve/water/" className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <div aria-label="button">
                <div className="flip-button-image-2" />
              </div>
              <p className="topic-under-box">Water</p>
            </a>

            {/* Waste */}
            <a href="/conserve/waste/" className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <div aria-label="button">
                <div className="flip-button-image-4" />
              </div>
              <p className="topic-under-box">Waste</p>
            </a>

            {/* Chemical */}
            <a href="/conserve/chemical/" className="icon-column" data-aos="fade-up" data-aos-duration="2500">
              <div aria-label="button">
                <div className="flip-button-image-3" />
              </div>
              <p className="topic-under-box">Chemical Management</p>
            </a>

          </div>
        </div>
      </center>
    </div>
  );
}
